import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import DrawerList from './DrawerList';

const drawerWidth = 247;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function SwipeableLeftDrawer() {
  const classes = useStyles();

  return (
    <Drawer
      className={[classes.drawer,classes.sectionDesktop]}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
    <Toolbar />
    <div className={classes.drawerContainer}>
      <DrawerList />
    </div>
  </Drawer>
);
}
